var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("Status")]),_c('PilotStatusForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }